import React from 'react';
import { Box, ButtonBase, Checkbox, FormControlLabel, makeStyles, Tooltip } from '@material-ui/core';
import Text from '../../../../../components/Text';
import { i18n } from '../../../../../language';
import { RemarksBgIcon } from '../../../../../components/Icon';

const useStyles = makeStyles((theme) => ({
  inputBase: {
    border: 'solid 1px #e4e7eb',
    borderRadius: '10px',
    height: '3.5rem',
    width: '24.5rem',
    padding: '0 1.25rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
  title: {
    fontSize: '0.875rem',
    fontWeight: '500',
    marginBottom: '0.625rem',
    color: '#7d86a9',
  },
  bgBorder: {
    borderTop: '0.5rem solid #f1f6ff',
  },
  colorRed: {
    color: '#ff0300',
  },
  checkBox: {
    marginRight: '0',
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
  emailAlertCheckBox: {
    marginRight: '0',
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '700',
      color: '#2E4469',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
  returnOrderTypeCheckBox: {
    marginRight: '0',
    '& .MuiRadio-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
      width: '9rem',
    },
    '& .Mui-checked': {
      color: '#538fff',
    },
  },
  radio: {
    borderColor: '#e4e7eb',
  },
  radioLabel: {
    flexBasis: '37%',
    '& .MuiRadio-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontWeight: '500',
      color: '#2e4469',
      fontSize: '1rem',
    },
    '& .Mui-checked': {
      color: '#538fff',
    },
  },
  markicon: {
    fontSize: '1.25rem',
    color: '#c0c6cb',
    marginLeft: '0.38rem',
  },
}));

const ArrowRight = () => {
  return (
    <Box alignItems="center" display="flex" height="100%" marginLeft="0.85rem">
      <svg width="6" height="20" viewBox="0 0 6 13" fill="none">
        <path
          d="M1 11.417L5 6.41699L1 1.41699"
          stroke="#538FFF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Box>
  );
};

const CentralStoreEmailAlert = ({ formData, setRecipientsListPopup, checkChange, setCentralStoreThresholdPopup }) => {
  const classes = useStyles();

  return (
    <Box bgcolor="#F5FAFF" borderRadius="1.14rem" p="0.25rem 1.25rem 1.25rem" marginBottom="1.5rem">
      <FormControlLabel
        id="setting_add_equipment_checkbox2"
        control={<Checkbox />}
        label={i18n.t('SETTING_EQUIPMENT_EMAIL_ALERT_WARNING')}
        className={classes?.emailAlertCheckBox}
        checked={formData?.emailAlertEnableYn}
        onChange={checkChange('emailAlertEnableYn')}
      />
      <Box pl="2rem" display="flex" justifyContent="space-between" alignItems="center" marginTop="0.57rem">
        <ButtonBase onClick={() => setRecipientsListPopup(true)}>
          <Text fontSize="1rem" color="#538FFF" fontWeight="700">
            {`${i18n.t('SETTING_EQUIPMENT_EDIT_RECIPIENTS_LISTS')} (${formData?.recipients?.length})`}
          </Text>
          <ArrowRight />
        </ButtonBase>
        <div style={{ backgroundColor: '#7D86A9', width: '2px', height: '20px' }} />
        <ButtonBase onClick={() => setCentralStoreThresholdPopup(true)}>
          <Box display="flex" alignItems="center">
            <Text fontSize="1rem" color="#538FFF" fontWeight="700">
              {i18n.t('SETTING_EQUIPMENT_ALERT_DEVICE_COUNT')}
            </Text>
            <Tooltip
              title={
                <Text color="inherit">
                  When available device is lower than this amount, email/HA Chat alert will be sent.
                </Text>
              }
            >
              <span style={{ display: 'inline-flex' }}>
                <RemarksBgIcon className={classes.markicon} />
              </span>
            </Tooltip>
          </Box>
          <ArrowRight />
        </ButtonBase>
      </Box>
    </Box>
  );
};

const SatelliteStoreEmailAlert = ({ formData, checkChange, setRecipientsListPopup }) => {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      bgcolor="#F5FAFF"
      borderRadius="1.14rem"
      p="1rem 1.25rem"
      marginBottom="1.5rem"
    >
      <FormControlLabel
        id="setting_add_equipment_checkbox2"
        control={<Checkbox />}
        label={i18n.t('SETTING_EQUIPMENT_EMAIL_ALERT_WARNING')}
        className={classes.emailAlertCheckBox}
        checked={formData.emailAlertEnableYn}
        onChange={checkChange('emailAlertEnableYn')}
      />
      <ButtonBase onClick={() => setRecipientsListPopup(true)}>
        <Text fontSize="1rem" color="#538FFF" fontWeight="700">
          {`${i18n.t('SETTING_EQUIPMENT_EDIT_RECIPIENTS_LISTS')} (${formData?.recipients?.length})`}
        </Text>
        <ArrowRight />
      </ButtonBase>
    </Box>
  );
};

export { CentralStoreEmailAlert, SatelliteStoreEmailAlert };
